import React from 'react'

import { useRecoilValue, useResetRecoilState } from 'recoil'

import { useIntl } from 'react-intl'

import { ModalConfirm } from 'mailup-web-components'

import { modalMessageUsageState } from '../recoil/state/page'

import useMessageSendAction from 'Hooks/useMessageSendAction'

const ModalMessageUsage = () => {
  const intl = useIntl()
  const { show, entityName, idMessage } = useRecoilValue(modalMessageUsageState)

  const handleCancel = useResetRecoilState(modalMessageUsageState)

  const handleConfirm = useMessageSendAction(idMessage)

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
      message={intl.formatMessage(
        { id: 'Load.EmailMessageList.ConfirmSendMessage' },
        { NAME: entityName }
      )}
      onClickConfirm={handleConfirm}
      onClickCancel={handleCancel}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
      data-mu-test='modal-message-usage'
    />
  )
}

export default ModalMessageUsage
